var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "30px",
    viewBox: "0 0 40 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(3.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.260068,22.895576 C29.2820084,21.6915267 33.496,18.9194759 33.496,15.6922185 C33.496,11.3600969 25.9027494,7.8482185 16.536,7.8482185",
    id: "Oval",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(25.016000, 15.371897) scale(-1, 1) rotate(-180.000000) translate(-25.016000, -15.371897) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45085005,22.2549335 C7.47279039,21.0508842 11.686782,18.2788334 11.686782,15.051576 C11.686782,11.5709064 6.78502187,8.61973803 2.82440737e-13,7.59412636",
    id: "Oval",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(5.843391, 14.924530) scale(-1, 1) translate(-5.843391, -14.924530) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.688,13.72 C18.688,15.0533333 16.688,15.0533333 16.688,13.72 C16.688,12.3866667 18.688,12.3866667 18.688,13.72",
    id: "Fill-3",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.688,7.36 C18.688,8.69333333 16.688,8.69333333 16.688,7.36 C16.688,6.02666667 18.688,6.02666667 18.688,7.36",
    id: "Fill-4",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6885001,1 C18.6885001,2.33333333 16.688,2.33333333 16.688,1 C16.688,-0.333333333 18.6885001,-0.333333333 18.6885001,1",
    id: "Fill-5",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Rectangle",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(8.056000, 21.835576) rotate(-315.000000) translate(-8.056000, -21.835576) ",
    points: "4.72609336 18.2058561 11.0860934 19.4051092 11.3859066 25.4652959"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnIcon);
export default __webpack_public_path__ + "static/media/turn-icon.ef9749f3baba14ed33a45d8b28030361.svg";
export { ForwardRef as ReactComponent };